import { finalize, tap } from 'rxjs/operators';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Line } from '../models/line.model';
import { Ont } from '../models/ont.model';
import { ModemChoiceService } from '../modem-choice.service';

@UntilDestroy()
@Component({
  selector: 'mprd-modem-choice-delete-ont',
  templateUrl: './modem-choice-delete-ont.component.html',
})
export class ModemChoiceDeleteOntComponent {
  @Input() line!: Line;
  @Input() ncName!: string;
  @Input() open = false;
  @Output() openChange = new EventEmitter<boolean>();
  @Output() deleted = new EventEmitter<Ont>();
  pending = false;

  constructor(private modemChoiceService: ModemChoiceService) {}

  onDelete(): void {
    this.pending = true;
    this.modemChoiceService
      .removeOnt(this.line.circuitId, this.ncName)
      .pipe(
        tap(() => {
          this.deleted.emit(this.line.devices.find(device => device.ncName === this.ncName));
          this.close();
        }),
        finalize(() => (this.pending = false)),
        untilDestroyed(this),
      )
      .subscribe();
  }

  onClose(): void {
    if (this.pending) return;
    this.close();
  }

  private close(): void {
    this.open = false;
    this.openChange.emit(false);
  }
}
